module.exports = __webpack_public_path__ + "img/honor.b498c22b.png";